export function verifyStrContain(originStr,subStr){
    const a = originStr.indexOf(subStr)
    return a >= 0

}